import { toast } from '@gmg/gmg-react-components';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import { useTransferLicenseSystem } from 'src/graphql/useTransferLicenseSystem';
import { getMoveLicensesEvent } from 'src/tracking';
import { TargetLicenseSystemData } from '../LicenseManagementAction';
import { TransferLicenseSystemModal } from './TransferLicenseSystemModal';

export interface TransferLicenseSystemModalContainerProps {
    targetLicenseSystems: Array<TargetLicenseSystemData>;
    sourceLicenseSystemId: string;
    orgId: string;
    onClose?: () => void;
};

const TransferLicenseSystemModalContainer: FC<TransferLicenseSystemModalContainerProps> = (props) => {
    const { t } = useTranslation();
    const { trackEvent } = useContext(AppContext);
    const moveLicenses = useTransferLicenseSystem(props.orgId, props.sourceLicenseSystemId);

    const handleSubmit = async (targetSystemId: string) => {
        trackEvent(getMoveLicensesEvent());
        try {
            await moveLicenses.mutateAsync(targetSystemId);
        } catch {
            toast.error(t('MoveLicensesModal.error_toast_desc', 'There was a problem sending the request. Please try again.'));
        } finally {
            props.onClose?.();
        }
    };

    return <TransferLicenseSystemModal
        targetLicenseSystems={props.targetLicenseSystems}
        sourceLicenseSystemId={props.sourceLicenseSystemId}
        onSubmit={handleSubmit}
        isSubmitting={moveLicenses.isPending}
        onClose={props.onClose}
    />;
};

export default TransferLicenseSystemModalContainer;
